import { getInvitationSessionEnv } from "@/services/invitation/env";

import DefaultInvitationSessionService from "./default-invitation-session-service";
import DevInvitationSessionService from "./dev-invitation-session-service";
import InvitationSessionService from "./invitation-session-service";

export function createInvitationSessionService(): InvitationSessionService {
  const { invitationSessionUrl, isDevelopmentLike } = getInvitationSessionEnv();
  return isDevelopmentLike
    ? new DevInvitationSessionService()
    : new DefaultInvitationSessionService(invitationSessionUrl);
}
